import React, { useEffect, useRef, useState } from 'react';
import { styled, Table, TableBody, TableHead, TableRow, TableCell, Typography, IconButton, Box, Avatar, Menu, MenuItem, Fade, Chip, CircularProgress, Button, Grid, TextField, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditSinger from './EditSingerModal';
import DelSinger from './DelSingerModal';
import axios from './../../axios/api';
import TablePagination from '@mui/material/TablePagination';
import InfoIcon from '@mui/icons-material/Info';
import { PREFIX_URL } from '../../components/Constants';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
const SongData = [
    {
        id: '1',
        title: 'الله الله',
        categori: 'جدیدترین ها',
        singer_name: 'مصطفی محسن زاده',
        tags: ['asd', 'asdasdasdasd']
    },
    {
        id: '2',
        title: 'الله الله',
        categori: 'جدیدترین ها',
        singer_name: 'مصطفی محسن زاده',
        tags: ['asd', 'asdasdasdasd', 'asdasdasas', 'ccc']
    }
];

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
    '& .MuiTablePagination-actions .Mui-disabled': {
        color: '#ccc',
    },
    '& .MuiTablePagination-actions': {
        color: 'rgba(0, 0, 0, 0.54)'
    },
}));
const TableSongs = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedId, setSelectedId] = useState(null); // New state to keep track of the selected row's id
    const open = Boolean(anchorEl);
    const [IsopenEditModal, setIsOpenEditModal] = useState(false);
    const [IsopenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [Data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalResults, setTotalResults] = useState(0);
    const [SearchFilter, setSearchFilter] = useState('');
    const [currentSound, setCurrentSound] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isAudioSupported, setIsAudioSupported] = useState(true); // State to track audio support

    const audioRef = useRef(new Audio());

    const handlePlayPause = (path) => {
        if (!isAudioSupported) return; // Check if audio is supported

        if (currentSound === path && isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
            setCurrentSound(null);
        } else {
            // Pause the currently playing audio if any
            if (currentSound && currentSound !== path) {
                audioRef.current.pause();
                setIsPlaying(false);
            }
            // Set the new audio source and play it
            audioRef.current.src = checkAndAddPrefix(path);
            audioRef.current.play();
            setIsPlaying(true);
            setCurrentSound(path);
        }
    };
    useEffect(() => {
        // Check if audio playback is supported
        const isAudioSupportedByBrowser = !!audioRef.current.canPlayType;
        setIsAudioSupported(isAudioSupportedByBrowser);
    }, []);

    useEffect(() => {
        const cleanup = () => {
            audioRef.current.pause(); // Pause the audio playback
            setIsPlaying(false);
            setCurrentSound(null);
            audioRef.current.src = ''; // Remove the audio source
        };

        return cleanup; // Cleanup function runs when component unmounts
    }, []);


    useEffect(() => {
        GetData();
    }, [page, rowsPerPage]);
    const handleClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(id); // Set the selected row's id
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsOpenEditModal(false);
    };

    const handleOpenEditModal = () => {
        setIsOpenEditModal(true);
        setAnchorEl(null);
    };

    const handleOpenDeleteModal = () => {
        setIsOpenDeleteModal(true);
        setAnchorEl(null);
    };

    const handleCloseEditModal = () => {
        setSelectedId(null); // Reset the selected row's id
        setIsOpenEditModal(false);
    };

    const handleCloseDeleteModal = () => {
        setSelectedId(null); // Reset the selected row's id
        setIsOpenDeleteModal(false);
    };


    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
    };



    const GetData = async (resetPage = false) => {
        if (resetPage) setPage(1);
        try {
            setIsLoading(true);
            let url = `/admin/track?is_paginate=true&count_of_page=${rowsPerPage}`;
            if (SearchFilter) url += `&search=${SearchFilter}`;
            const res = await axios.get(`${url}&page=${resetPage ? 1 : page}`);
            const dataRecived = res.data?.data?.data?.data;
            if (page > 1 && dataRecived?.length == 0) {
                GetData(true);
            } else {
                setData(dataRecived);
                setTotalResults(res.data?.data?.data?.total);
            }

        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilter = () => {
        GetData(true);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleFilter();
        }
    };

    const checkAndAddPrefix = (url) => {
        const prefix = PREFIX_URL;
        if (url && url.startsWith('/uploads/')) {
            return `${prefix}${url}`;
        }
        return url;
    };

    return (
        <>
            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item lg={10} md={10} sm={12}>
                    <TextField
                        label="جستجو"
                        placeholder='جستجو براساس عنوان پلن'
                        fullWidth
                        value={SearchFilter}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => setSearchFilter(e.target.value)}
                        variant="outlined"
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={12}>
                    <Button
                        onClick={handleFilter}
                        sx={{ padding: '16.5px 14px' }}
                        color="secondary"
                        fullWidth
                        variant="contained"
                        size="large"
                    >
                        <Typography color="white">فیلتر</Typography>
                    </Button>
                </Grid>
            </Grid>

            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {Data?.length === 0 ? (
                        <Typography variant="h6" align="center" sx={{ marginTop: 2 }}>
                            هیچ داده ای یافت نشد
                        </Typography>
                    ) : (
                        <>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                #
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                عنوان نوحه
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                نام مداح
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                دسته بندی
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                تگ ها
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Typography color="textSecondary" variant="h6">
                                                عملیات
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Data.map((SongItem) => (
                                        <TableRow key={SongItem.id}>
                                            <TableCell sx={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                                                <IconButton onClick={() => handlePlayPause((SongItem?.path))}>
                                                    {currentSound === (SongItem?.path) && isPlaying ? (
                                                        <PauseIcon />
                                                    ) : (
                                                        <PlayArrowIcon />
                                                    )}
                                                    {!isAudioSupported && (
                                                        <Typography variant="caption" >
                                                            مرورگر شما از صدا پشتیبانی نمی کند.
                                                        </Typography>
                                                    )}
                                                </IconButton>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">{SongItem.title}</Typography>
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                {SongItem.artist ?
                                                    <Typography variant="body2">{SongItem.artist?.name + " " + SongItem.artist?.family}</Typography>
                                                    :
                                                    <Typography variant="body2">-</Typography>

                                                }
                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    SongItem?.categories?.length > 0 ?
                                                        SongItem?.categories?.map((cat) =>
                                                            <Chip
                                                                label={cat.title}
                                                                size="small"
                                                                color='secondary'
                                                                sx={{
                                                                    ml: "auto",
                                                                    color: 'white',
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                }}
                                                            ></Chip>) :
                                                        <Typography variant="body2">-</Typography>
                                                }

                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Tooltip

                                                    title={
                                                        SongItem?.tags?.length > 0 ?
                                                            SongItem?.tags?.map((cat) =>
                                                                <Chip
                                                                    label={cat.title}
                                                                    variant='outlined'
                                                                    size="small"
                                                                    sx={{
                                                                        margin: 0.2,
                                                                        color: 'white',
                                                                        fontSize: "10px",
                                                                        fontWeight: "500",
                                                                    }}
                                                                ></Chip>) :
                                                            <Typography variant="body2">-</Typography>
                                                    }

                                                >
                                                    <IconButton>
                                                        <InfoIcon />
                                                    </IconButton>
                                                </Tooltip>

                                            </TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="body2">
                                                    <IconButton
                                                        aria-label="more"
                                                        id="fade-button"
                                                        aria-controls={open ? 'long-menu' : undefined}
                                                        aria-expanded={open ? 'true' : undefined}
                                                        aria-haspopup="true"
                                                        onClick={(event) => handleClick(event, SongItem.id)} // Pass the id here
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    <Menu
                                                        id="fade-menu"
                                                        MenuListProps={{
                                                            'aria-labelledby': 'fade-button',
                                                        }}
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        TransitionComponent={Fade}
                                                    >
                                                        <MenuItem onClick={handleOpenEditModal}>ویرایش</MenuItem>
                                                        <MenuItem onClick={handleOpenDeleteModal}>حذف</MenuItem>
                                                    </Menu>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <StyledTablePagination
                                component="div"
                                count={totalResults}
                                rowsPerPage={rowsPerPage}
                                page={page - 1}  // Adjusting for the 0-based index of TablePagination
                                onPageChange={handleChangePage}
                                rowsPerPageOptions={[]} // Hide rows per page dropdown
                                labelRowsPerPage="" // Hide label
                                showFirstButton
                                showLastButton
                            />
                        </>
                    )}
                </>
            )}
            {IsopenEditModal &&
                <EditSinger open={IsopenEditModal}
                    id={selectedId}
                    refreshData={GetData}

                    handleCloseModal={handleCloseEditModal} />}
            {IsopenDeleteModal &&
                <DelSinger id={selectedId}
                    open={IsopenDeleteModal}
                    refreshData={GetData}

                    handleCloseModal={handleCloseDeleteModal} />}
        </>
    );
};

export default TableSongs;
